import { Meteor } from 'meteor/meteor';
import { check } from 'meteor/check';
import Videos from '../Videos';

// VideoSchema
//   owner
//   project
//   createdAt
//   updatedAt
//   name
//   description
//   shared
//   audience
//   url
//   geometryFileName
//   logFileName
//   latLng0
//   noCoordinates
//   option
//   type
//   deleted
//   tags
//   track
//   controlPoints
//   coordinatesDataType
//   annotationTemplates

Meteor.publish('videos', function videos(projectId) {
  check(projectId, String);
  return Videos.find(
    { owner: this.userId, project: projectId },
    { fields: { createdAt: 1, updatedAt: 1, name: 1, latLng0: 1, type: 1, deleted: 1, tags: 1 } }
  );
});

Meteor.publish('videos.project', function videos(projectId) {
  check(projectId, String);
  return Videos.find({ owner: this.userId, project: projectId });
});

// Note: videos.view is also used when editing an existing document.
Meteor.publish('videos.view', function videosView(videoId) {
  check(videoId, String);
  return Videos.find({ _id: videoId, owner: this.userId });
});

Meteor.publish('videos.public', function videosPublic(videoId) {
  check(videoId, String);
  return Videos.find(
    { _id: videoId, shared: true },
    { fields: { owner: 0, geometryFileName: 0, logFileName: 0 } }
  );
});

Meteor.publish('videos.publicProject', function videosPublicProject(projectId) {
  check(projectId, String);
  return Videos.find(
    { project: projectId, shared: true },
    { fields: { createdAt: 1, updatedAt: 1, name: 1, latLng0: 1, type: 1, deleted: 1, tags: 1 } }
  );
});

Meteor.publish('videos.dashboard', function videosDashboard() {
  return Videos.find(
    { shared: true, audience: { $in: ['all', 'private'] }, deleted: 'no' },
    {
      fields: {
        createdAt: 1,
        updatedAt: 1,
        name: 1,
        tags: 1,
        latLng0: 1,
        type: 1,
        deleted: 1,
        audience: 1
      }
    }
  );
});

Meteor.publish('videos.atlas', function videosAtlas() {
  return Videos.find({});
});

Meteor.publish('videos.maps', function videosMaps() {
  return Videos.find({ deleted: 'no', owner: this.userId });
});
